'use client';

import '../../styles/not-found.css';
import { Button } from './button';

interface NotFoundProps {
  onClick: () => void;
  text: { description: string; buttonText: string };
  disabled?: boolean;
}

export default function NotFound({ onClick, text, disabled }: NotFoundProps) {
  return (
    <>
      <div id="floating-kibis">
        <img src="/kibi.png" alt="Kibi" className="kibi kibi1" width="200" height="243" />
        <img src="/kibi.png" alt="Kibi" className="kibi kibi2" width="200" height="243" />
        <img src="/kibi.png" alt="Kibi" className="kibi kibi3" width="200" height="243" />
        <img src="/kibi.png" alt="Kibi" className="kibi kibi4" width="200" height="243" />
        <img src="/kibi.png" alt="Kibi" className="kibi kibi5" width="200" height="243" />
        <img src="/kibi.png" alt="Kibi" className="kibi kibi6" width="200" height="243" />
      </div>
      <div className="c">
        <h1 className="mb-7 text-9xl">404</h1>
        <p className="mb-12 text-5xl">{text.description}</p>
        <Button onClick={onClick} disabled={disabled}>
          {text.buttonText}
        </Button>
      </div>
    </>
  );
}
